const CONST = {
    'SET_CONFIG':'DEPARTMENT/SET_CONFIG',
    'SET_SELECTED_ITEM':'DEPARTMENT/SET_SELECTED_ITEM',
    'FETCH_ITEM_SUCCESS':'DEPARTMENT/FETCH_ITEM_SUCCESS',
    'FETCH_ITEM_FAILED':'DEPARTMENT/FETCH_ITEM_FAILED',
    'FETCH_ITEMS_SUCCESS':'DEPARTMENT/FETCH_ITEMS_SUCCESS',
    'FETCH_ITEMS_FAILED':'DEPARTMENT/FETCH_ITEMS_FAILED',
    'ADD_ITEM_SUCCESS':'DEPARTMENT/ADD_ITEM_SUCCESS',
    'ADD_ITEM_FAILED':'DEPARTMENT/ADD_ITEM_FAILED',
    'UPDATE_ITEM_SUCCESS':'DEPARTMENT/UPDATE_ITEM_SUCCESS',
    'UPDATE_ITEM_FAILED':'DEPARTMENT/UPDATE_ITEM_FAILED',
    'DELETE_ITEM_SUCCESS':'DEPARTMENT/DELETE_ITEM_SUCCESS',
    'DELETE_ITEM_FAILED':'DEPARTMENT/DELETE_ITEM_FAILED',
}

export default CONST;